<div class="row m-t-sm">
  <div class="col-12">
    <plyca-ui-filter-panel
      [config]="{
        header: ('General.filters' | translate),
        toggleable: true,
        collapseIcon: 'fa fa-chevron-down',
        expandIcon: 'fa fa-chevron-up',
        isFormPlyca: true,
        model: model,
        formConfigFilters: formConfigFilters,
        jsonFile: 'admin/product-maintenance/productMaintenanceSettings.json'
      }"
      (valuesFormChange)="valuesOnChange($event)"
    >
      <div class="d-flex justify-content-end mr-4 pr-3">
        <plyca-ui-button-generic
          [config]="{
            buttonClass: 'btn btn-lg btn-primary',
            type: 'submit',
            disabled: !isSearchButtonEnabled()
          }"
          (clickEvent)="onClickFilter()"
        >
          <span> {{ 'Filter' }} </span>
        </plyca-ui-button-generic>
      </div>
    </plyca-ui-filter-panel>
  </div>
</div>
